import React from 'react';
import { View } from 'react-native';

// Web-compatible SafeAreaView component
// On web, safe area is typically handled by CSS and viewport meta tags
export const SafeAreaView = ({ style, ...props }) => {
  return <View style={[{ flex: 1 }, style]} {...props} />;
};

// Web-compatible SafeAreaProvider - just passes through children
export const SafeAreaProvider = ({ children, ...props }) => {
  return <View {...props}>{children}</View>;
};

// Mock hook for web - returns zero insets since web doesn't need safe area handling
export const useSafeAreaInsets = () => ({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
});

// Mock hook for web  
export const useSafeAreaFrame = () => ({
  x: 0,
  y: 0,
  width: window.innerWidth || 0,
  height: window.innerHeight || 0,
});

// Export default as SafeAreaView for compatibility
export default SafeAreaView;
